import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LoaderService } from "src/app/loader/loader.service";
import { environment } from "src/environments/environment";
import { ChargeBodyPut } from "../models/charge-body-put";
import { Payment } from "../models/payment";
import { PaymentResult } from "../models/payment-result";
import { ChargesStoreService } from "../services/charges-store.service";
import { ChargesService } from "../services/charges.service";

@Component({
  selector: "app-recurrences-charges",
  templateUrl: "./recurrences-charges.component.html",
  styleUrls: ["./recurrences-charges.component.scss"],
})
export class RecurrencesChargesComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  checkAll: boolean;

  payments: Payment[];
  paymentsSelected: Payment[] = [];
  paymentItemsSelected = 0;

  mot_reprovado: string;
  modalActive: NgbModalRef;

  private unsubscribe$ = new Subject();

  constructor(
    public router: Router,
    public chargesStore: ChargesStoreService,
    private chargesService: ChargesService,
    private loaderService: LoaderService,
    private modalService: NgbModal
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getRecurrencesPayments();
  }

  getRecurrencesPayments() {
    this.chargesStore.recurrencesPayments$.pipe(takeUntil(this.unsubscribe$)).subscribe(paymentResult => {
      this.pageSize = paymentResult.limit;
      this.page = paymentResult.page;

      this.collectionSize =
        paymentResult.total_docs !== undefined && paymentResult.total_docs !== null
          ? paymentResult.total_docs
          : paymentResult.result.length;
      this.payments = paymentResult.result.map(payment => {
        this.paymentsSelected.find(selected => selected._id === payment._id)
          ? (payment.selected = true)
          : (payment.selected = false);

        return payment;
      });
    });
  }

  getTipoPayment(payment: Payment): string {
    return this.chargesStore.getTipoPayment(payment);
  }

  // Verifica se há recebimentos válidos selecionados para aprovar/rejeitar
  get hasValidReceiptsSelected(): boolean {
    return this.paymentsSelected.some(payment => {
      // Deve ser do tipo "Recebimento"
      const isRecebimento = this.getTipoPayment(payment) === "Recebimento";

      // Não deve ter status de enviado ou processado no ERP
      const isNotProcessed =
        !payment.processamento_erp ||
        !payment.processamento_erp.status ||
        (!payment.processamento_erp.status.includes("enviado") &&
          !payment.processamento_erp.status.includes("processado"));

      return isRecebimento && isNotProcessed;
    });
  }
  async onChangePagination() {
    const loader = await this.loaderService.notifica({
      title: "Atualizando paginação...",
      date: moment().toISOString(),
      type: "loading",
    });

    await this.chargesStore.getPayments(this.env.selected.cnpj, this.pageSize, this.page);

    loader.dismiss();
  }

  onChangeSelectionPayment(payment: Payment) {
    if (payment.selected) {
      const selectedIndex = this.paymentsSelected.findIndex(selected => selected._id === payment._id);
      if (selectedIndex === -1) {
        this.paymentsSelected.push(payment);
      }
    } else {
      this.paymentsSelected = this.paymentsSelected.filter(selected => selected._id !== payment._id);
    }

    this.paymentItemsSelected = this.paymentsSelected.length;
  }

  async onToggleSelectionPayments(checkAll: boolean) {
    let page = 1;
    const limit = 50;
    let paymentResult: PaymentResult;
    let total_docs: number;
    let payments: Payment[] = [];

    if (checkAll) {
      const loader = await this.loaderService.notifica({
        title: "Carregando seleção...",
        date: moment().toISOString(),
        type: "loading",
      });

      paymentResult = await this.chargesService
        .getPayments(this.env.selected.cnpj, "recorrencia", this.chargesStore.paymentFilter, limit, page)
        .toPromise();

      payments = paymentResult.result;
      total_docs = paymentResult.total_docs;

      while (payments.length < total_docs) {
        page++;
        paymentResult = await this.chargesService
          .getPayments(this.env.selected.cnpj, "recorrencia", this.chargesStore.paymentFilter, limit, page)
          .toPromise();

        payments.push(...paymentResult.result);
      }

      this.paymentsSelected = payments;

      loader.dismiss();
    } else {
      this.paymentsSelected = [];
    }

    this.paymentItemsSelected = this.paymentsSelected.length;

    await this.onChangePagination();
  }

  openModal(modal) {
    if (this.hasValidReceiptsSelected) {
      this.modalActive = this.modalService.open(modal, { size: "lg" });
    }
  }

  async onSubmit(status: string) {
    const chargesBodyPut: ChargeBodyPut = {};

    const loader = await this.loaderService.notifica({
      title: "Processando operação...",
      date: moment().toISOString(),
      type: "loading",
    });

    chargesBodyPut.operador = this.env.user.codigo_externo;
    chargesBodyPut.ids = this.paymentsSelected.map(payment => payment._id);
    if (status.includes("rejeitado")) {
      chargesBodyPut.mot_reprovado = this.mot_reprovado;
    }

    const chargesMsgResult = await this.chargesService
      .updateCharges(this.env.selected.cnpj, "payments", status, chargesBodyPut)
      .toPromise();

    if (chargesMsgResult.ok) {
      this.checkAll = false;
      this.paymentsSelected = [];
      this.paymentItemsSelected = this.paymentsSelected.length;
      this.mot_reprovado = null;
    }

    loader.dismiss();
    await this.onChangePagination();

    this.modalActive.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
